// Front/side image swiper for collection product cards (card-image-swiper.liquid).
// Uses the Swiper 8 bundle already loaded on collection pages, configured like the
// PDP carousel so the gesture feel matches: rewind rather than loop, so the arrows
// wrap in both directions and never render a disabled state.

(function () {
  "use strict";

  const ROOT_SELECTOR = "[data-card-imgswiper]";
  const instances = new WeakMap();

  function stopCardNavigation(element) {
    // The controls sit outside the slide anchors, so they never navigate on their
    // own. Guard only the press events, and in the bubble phase, so Swiper's own
    // click handler still runs.
    ["pointerdown", "mousedown", "touchstart"].forEach((type) => {
      element.addEventListener(type, (event) => event.stopPropagation());
    });
  }

  function initSwiper(root) {
    if (instances.has(root)) return instances.get(root);
    if (root.classList.contains("is-single")) return null;
    if (typeof window.Swiper !== "function") return null;

    const viewport = root.querySelector(".ombraz-card-imgswiper__viewport");
    if (!viewport) return null;

    const prev = root.querySelector(".ombraz-card-imgswiper__nav--prev");
    const next = root.querySelector(".ombraz-card-imgswiper__nav--next");
    const pagination = root.querySelector(".ombraz-card-imgswiper__pagination");

    const swiper = new window.Swiper(viewport, {
      slidesPerView: 1,
      spaceBetween: 0,
      // rewind, not loop: two slides plus Swiper's loop clones is a known bad mix,
      // and rewind keeps both arrows live at either end.
      rewind: true,
      simulateTouch: true,
      touchEventsTarget: "wrapper",
      // Each slide wraps its image in a PDP link, so a swipe would otherwise end
      // in a navigation. These swallow the click that follows a drag, and only
      // that click — a plain tap on the image still opens the PDP.
      preventClicks: true,
      preventClicksPropagation: true,
      navigation: { nextEl: next, prevEl: prev },
      pagination: pagination ? { el: pagination, clickable: true } : false,
    });

    [prev, next, pagination].forEach((el) => el && stopCardNavigation(el));

    instances.set(root, swiper);
    return swiper;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(initSwiper);
  }

  // Called by the lens thumbnail handlers when the shopper picks another variant:
  // both images belong to the new variant, so swap them and return to the front.
  function applyVariantImages(card, frontSrc, sideSrc) {
    if (!card) return;
    const root = card.querySelector(ROOT_SELECTOR);
    if (!root) return;

    const front = root.querySelector("[data-feaure-image]");
    const side = root.querySelector("[data-card-side-image]");

    if (front && frontSrc) {
      requestAnimationFrame(() => {
        front.src = frontSrc;
      });
    }

    const hasSide = Boolean(sideSrc);
    root.classList.toggle("is-single", !hasSide);

    if (side && hasSide) {
      requestAnimationFrame(() => {
        side.src = sideSrc;
      });
    }

    const swiper = instances.get(root);
    if (swiper) {
      swiper.slideTo(0, 0);
      swiper.update();
    }
  }

  // Best Seller cards start hidden, so Swiper measures them at zero width.
  function refresh(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      const swiper = instances.get(root) || initSwiper(root);
      if (swiper) swiper.update();
    });
  }

  window.OmbrazCardImageSwiper = { initAll, refresh, applyVariantImages };

  document.addEventListener("DOMContentLoaded", () => initAll());
})();
